class VariantNotice extends HTMLElement {
  updateStockMessage = (variantId) => {
    const variantObject = this.variantJson.find((obj) => obj[variantId]);

    if (!variantObject) {
      console.error("Variant object not found for ID:", variantId);
      return;
    }

    const stockMessage = Object.values(variantObject)[0].notice;
    const isPreorder = Object.values(variantObject)[0].preorder;

    if (!stockMessage || stockMessage === "null" || isPreorder) {
      this.classList.add("hidden");
    } else {
      this.classList.remove("hidden");
      this.messageContainer.innerHTML = stockMessage;
    }
  };

  connectedCallback() {
    this.scriptTag = this.querySelector("script");
    this.messageContainer = this.querySelector("p");

    if (!this.scriptTag || !this.messageContainer) {
      console.warn("Required elements not found in VariantNotice");
      return;
    }

    this.variantJson = JSON.parse(this.scriptTag.innerText);

    document.addEventListener("variant:changed", (evt) => this.updateStockMessage(evt.detail.variant.id));
  }
}

customElements.define("variant-stock-notice", VariantNotice);
